import { Injectable } from '@angular/core';
import { DataSourceDetail, DataSourceListItem } from '@app/domain/entities';
import {
  BodyCreateDataSource,
  CreateDataSourceResponse,
  DataSourceListParams,
  SystemDataSourceParams,
} from '@app/domain/models';
import { DataSourcesRepository } from '@app/domain/repositories';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { DataSourcesService } from '../api-clients';
import { DataSourcesMapper } from '../mappers';

@Injectable()
export class DataSourcesRepositoryImpl implements DataSourcesRepository {
  private readonly _dataSourcesMapper = new DataSourcesMapper();

  constructor(private readonly _dataSourcesService: DataSourcesService) {}

  getList(
    params: DataSourceListParams
  ): Observable<PaginatedResponse<DataSourceListItem>> {
    const dataSourceListDTO = this._dataSourcesService.getList(params);
    return dataSourceListDTO.pipe(
      map(dto => this._dataSourcesMapper.dataSourceListItemToDomain(dto))
    );
  }

  getValueSystemDataSource(
    params: SystemDataSourceParams
  ): Observable<Record<string, string[]>> {
    return this._dataSourcesService.getValueSystemDataSource(params);
  }

  detail(dataSourceId: number): Observable<DataSourceDetail> {
    const dataSourceDetailDTO = this._dataSourcesService.detail(dataSourceId);
    return dataSourceDetailDTO.pipe(
      map(dto => this._dataSourcesMapper.dataSourceDetailToDomain(dto))
    );
  }

  create(body: BodyCreateDataSource): Observable<CreateDataSourceResponse> {
    return this._dataSourcesService.create(body);
  }

  update(body: BodyCreateDataSource): Observable<void> {
    return this._dataSourcesService.update(body);
  }

  getDataSourceFromJP(): Observable<Record<string, string[]>> {
    return this._dataSourcesService.getDataSourceFromJP();
  }

  updateStatus(dataSourceId: number, isActive: boolean): Observable<void> {
    return this._dataSourcesService.updateStatus(dataSourceId, isActive);
  }

  deleteValue(dataSourceValueId: number): Observable<void> {
    return this._dataSourcesService.deleteValue(dataSourceValueId);
  }
}
